import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { IncomingMessageNotification } from '../../../models';
import { markAllMessagesAsRead, markMessageAsRead } from '../../../store/general/actions';
import { push } from 'connected-react-router';
import { paths } from '../../constants';
import { getRecentMessages, getUnreadMessages } from '../../../store/general/selectors';
import MessagesMenu, { MessagesMenuStateProps, MessagesMenuDispatchProps } from './MessagesMenu';

const mapStateToProps = (state: ApplicationState): MessagesMenuStateProps => ({
    unreadMessages: getUnreadMessages(state),
    recentMessages: getRecentMessages(state),
});

const mapDispatchToProps = (dispatch: any): MessagesMenuDispatchProps => ({
    onMarkAllAsRead: () => dispatch(markAllMessagesAsRead()),
    onMessageClick: (message: IncomingMessageNotification) => {
        // Mark message as read
        dispatch(markMessageAsRead(message.clientId, message.id, true));

        // Navigate to client with communication tab open via location state
        dispatch(push({
            pathname: paths.clients(),
            search: `?id=${message.clientId}&tab=communication`,
        }));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(MessagesMenu);
